<template>
    <div class="searchCard insightBanner">
        <div class="insightBanner__headlineContainer">
            <svg
                v-if="insight"
                height="24px"
                width="24px"
                class="insightBanner__headlineIcon"
                aria-hidden="true">
                <use :href="bannerIcon" />
            </svg>
            <span
                class="insightBanner__headline"
                :class="!insight ? 'text-upper text-bold' : ''">{{ bannerTitle }}</span>
        </div>
        <div class="insightBanner__content">
            <span v-if="!insight">
                <p
                    v-if="bannerInsights.includes('market')"
                    v-html="marketOnly"></p>
                <p
                    v-else-if="bannerInsights.includes('consumer')"
                    v-html="consumerOnly"></p>
            </span>
            <div v-else>
                <p v-if="urlQuery === ''">
                    {{ bannerContent }}
                </p>
                <p
                    v-else-if="insightResultCounter === 1"
                    v-html="bannerContentSingleCount">
                </p>
                <p
                    v-else
                    v-html="bannerContentCount">
                </p>
            </div>
        </div>
        <div
            v-if="bannerLink"
            class="insightBanner__linkContainer">
            <button
                class="insightBanner__link"
                :data-gtm="`insightBanner__${ bannerTitle }`"
                @click="selectContentType([bannerName])">
                {{ bannerLinkTitle }}
            </button>
            <svg
                height="12px"
                width="12px"
                class="insightBanner__linkIcon"
                aria-hidden="true">
                <use href="#iconChevronRightBold" />
            </svg>
        </div>
    </div>
</template>

<script>
    import Translator from 'tools/trans';
    import { mapActions, mapGetters } from 'vuex';

    const CONTENT_TYPE = 'contentType';
    export default {
        name: 'InsightBanner',
        props: {
            insight: { type: Boolean, default: false },
            bannerIcon: { type: String, default: '' },
            bannerName: { type: String, default: '' },
            bannerTitle: { type: String, default: '' },
            bannerContent: { type: String, default: '' },
            bannerContentCount: { type: String, default: '' },
            bannerContentSingleCount: { type: String, default: '' },
            bannerLinkTitle: { type: String, default: '' },
            bannerLink: { type: Boolean, default: false },
            insightResult: { type: Boolean, default: false },
            insightResultCounter: { type: Number, default: 0 },
        },
        data() {
            return {
                marketOnly: this.trans('ONLY_MARKET_INSIGHTS'),
                consumerOnly: this.trans('ONLY_CONSUMER_INSIGHTS'),
            };
        },
        computed: {
            ...mapGetters('search', ['bannerInsights']),
            urlQuery() {
                const uri = window.location.search.substring(1);
                const URLSearchParams = window.URLSearchParams;
                const urlParams = new URLSearchParams(uri);
                const query = urlParams.get('q');

                return query;
            },
        },
        methods: {
            trans: Translator.trans,
            ...mapActions('search', ['setContentType', 'setActiveTab', 'calculateWhichBannerToShow']),
            selectContentType(contentArray) {
                this.setContentType(contentArray);
                this.setActiveTab(CONTENT_TYPE);
                this.calculateWhichBannerToShow();
                // scroll to top after click on link in insight banners
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE
            },
        },
    };
</script>
